function getFilenameFromHeader(response: Response | XMLHttpRequest): string {
	const contentDispositionHeader = response instanceof Response
		? response.headers.get("Content-Disposition")
		: response.getResponseHeader("Content-Disposition");

	if (!contentDispositionHeader)
		throw new Error("Content-Disposition header not found. Check CORS policy to ensure this header is exposed.");

	const match = contentDispositionHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
	let filename = match ? match[1] : null;

	if (!filename) throw new Error("Filename didn't exist in the header.");

	filename = filename.replace(/"/g, "");

	return filename;
}

export const downloadUtility = {
	getFilenameFromHeader,
};
